interface PwaLaunchParams {
  targetURL?: string;
}

interface PwaLaunchQueue {
  setConsumer(consumer: (params: PwaLaunchParams) => void): void;
}

type WindowWithLaunchQueue = Window & {
  launchQueue?: PwaLaunchQueue;
};

/**
 * Handles in-scope links captured by an installed PWA without reloading the
 * existing app client. Keeping the current document alive also keeps its
 * in-memory access token while React Router processes the partner exit URL.
 */
export function registerPwaLaunchHandler(): void {
  const launchQueue = (window as WindowWithLaunchQueue).launchQueue;
  if (!launchQueue) {
    return;
  }

  launchQueue.setConsumer(({ targetURL }) => {
    if (!targetURL) {
      return;
    }

    const target = new URL(targetURL, window.location.href);
    if (target.origin !== window.location.origin) {
      return;
    }

    const currentUrl = `${window.location.pathname}${window.location.search}${window.location.hash}`;
    const targetUrl = `${target.pathname}${target.search}${target.hash}`;
    if (targetUrl === currentUrl) {
      return;
    }

    window.history.pushState(null, '', targetUrl);
    window.dispatchEvent(new PopStateEvent('popstate'));
    window.focus();
  });
}
